export const LANDING = '/';
export const SIGN_IN = '/signin';
export const ADMIN = '/admin';
export const EDIT = '/edit';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';